import { PaintedScene } from '../PaintedScene';

export const OPEN_DESERT_PHASER_KEY = 'OpenDesertScene' as const;
export const OPEN_DESERT_MANIFEST_KEY = 's-214-open-desert' as const;

export class OpenDesertScene extends PaintedScene {
  constructor() {
    super(OPEN_DESERT_PHASER_KEY, OPEN_DESERT_MANIFEST_KEY);
  }
}
